// extracted by mini-css-extract-plugin
export default {"is-selected-all":"table_is-selected-all__IwXUY__oBlIk"};